import { BusinessSlot, ShiftProviderUser } from 'models';
import React, { useState } from 'react';
import { Link } from 'library/ui';
import { EventBusy } from '@mui/icons-material';
import CancelModal from './CancelModal';

interface CancelShiftModalTriggerProps {
    provider: ShiftProviderUser;
    slot: BusinessSlot;
    refresh: () => void;
    providerId?: number;
}

const CancelShiftModalTrigger = ({ provider, slot, refresh, providerId }: CancelShiftModalTriggerProps) => {
    const [cancelOpen, setCancelOpen] = useState(false);

    return (
        <>
            <Link onClick={() => setCancelOpen(true)} icon={<EventBusy sx={{ fontSize: 16 }} />}>
                Cancel this shift
            </Link>
            <CancelModal
                open={cancelOpen}
                onClose={() => setCancelOpen(false)}
                slot={slot}
                providerName={provider?.first_name}
                refresh={refresh}
                providerId={providerId}
            />
        </>
    );
};

export default CancelShiftModalTrigger;
